// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Price = require("../common/Price.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PriceRangeCriteria_priceRange_graphql = require("../../__generated__/PriceRangeCriteria_priceRange_graphql.bs.js");

let convertFragment = PriceRangeCriteria_priceRange_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PriceRangeCriteria_priceRange_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PriceRangeCriteria_priceRange_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PriceRangeCriteria_priceRange_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PriceRangeCriteria_priceRange_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PriceRangeCriteria(props) {
  let match = RescriptRelay_Fragment.useFragment(PriceRangeCriteria_priceRange_graphql.node, convertFragment, props.priceRange);
  return JsxRuntime.jsx(Price.make, {
    children: match.minPrice.formatted + ` - ` + match.maxPrice.formatted + (
      props.priceType === "monthly" ? "/month" : ""
    ),
    size: props.size
  });
}

let make = PriceRangeCriteria;

exports.Fragment = Fragment;
exports.make = make;
/* Price Not a pure module */
